import React, { memo, useEffect, useMemo } from 'react'
import {
    Box,
    CircularProgress,
    Divider,
    useTheme
} from '@mui/material'
import { primary, red } from '../../assets/colors'
import { Security, SecurityCategory_CategoryCode } from '../../proto/generated/security'
import { isTradeableSecurity } from '../../util/cashInstrument'
import { useDispatch, useSelector } from 'react-redux'
import { selectOrderBook } from '../../selectors/security'
import { getSecurityKey } from '../../util/security'
import { getOrderBook } from '../../services/apis/candles'
import { updateOrderBooks } from '../../reducer/security.reducer'
import MarketDepth from '../marketDepth/marketDepth'
import OrderBookOverview from '../orderBookOverview/orderBookOverview'

interface OrderBookProps {
    security: Security
}

export const bidFirstColumnStyle = {
    borderBottom: 'none',
    color: primary,
    padding: '2px',
    fontSize: '13px',
    textAlign: 'start'
}

export const bidRowStyle = {
    borderBottom: 'none',
    color: primary,
    padding: '2px',
    fontSize: '13px',
    textAlign: 'right'
}

export const offerFirstColumnStyle = {
    borderBottom: 'none',
    padding: '2px',
    textAlign: 'start',
    fontSize: '13px',
    color: red
}

export const offerRowStyle = {
    borderBottom: 'none',
    textAlign: 'right',
    color: red,
    padding: '2px',
    fontSize: '13px'
}

const OrderBookDialog: React.FC<OrderBookProps> = ({ security }) => {
    const dispatch = useDispatch()
    const securityKey = useMemo(() => security ? getSecurityKey(security.exchange, security.code) : '', [security])
    const orderBook = useSelector(selectOrderBook(securityKey))
    const theme = useTheme()

    useEffect(() => {
        if (!orderBook && security) {
            getOrderBook({
                security: security,
                dispatch: dispatch
            })
                .then((result) => {
                    const orderBook = { ...result }
                    if (!orderBook.security) {
                        orderBook.security = { ...security }
                    }
                    dispatch(updateOrderBooks([orderBook]))
                })
                .catch((error) => {
                    console.error('Error fetching order book:', error)
                })
        }
    }, [orderBook, security])

    return (
        <div>
            {!orderBook ? (
                <Box
                    sx={{
                        display: 'flex',
                        // height: '200px',
                        width: '450px',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <CircularProgress size={50} />
                </Box>
            ) : orderBook ? (
                <Box padding={theme.spacing(1, 2, 0)}>
                    {
                        security.categoryCode === SecurityCategory_CategoryCode.INDEX ? null :
                        <>
                            <MarketDepth security={security} tradeable={isTradeableSecurity(security)} />
                            <Divider sx={{ borderColor: '#88888815', marginTop: 1 }} />
                        </>
                    }
                    <Box sx={{ paddingY: 1 }}>
                        <OrderBookOverview security={security} />
                    </Box>
                </Box>
            ) : null}
        </div>
    )
}

export default memo(OrderBookDialog)